import { render, staticRenderFns } from "./1-PlayerDetails.vue?vue&type=template&id=3c6c4b67&scoped=true"
import script from "./1-PlayerDetails.vue?vue&type=script&lang=js"
export * from "./1-PlayerDetails.vue?vue&type=script&lang=js"
import style0 from "./1-PlayerDetails.vue?vue&type=style&index=0&id=3c6c4b67&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6c4b67",
  null
  
)

export default component.exports